import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import DateFnsUtils from "@date-io/date-fns";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { blue } from "@material-ui/core/colors";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Box from "@material-ui/core/Box";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

import TransmittalDocument from "./TransmittalDocument";

// Material-UI Element
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import {
  getTransmittalFollowingList,
  getTransmittalPurposeList,
} from "../../../../dataSource/transmittal";

// Custom Style
import { rfiDetailFormStyle } from "../../../../styles/jss/components/RFI/rfiDetailFormStyle";
const CustomCheckbox = withStyles({
  root: {
    color: blue[600],
    "&$disabled": {
      color: blue[500],
    },
  },
  checked: {},
  disabled: {},
})((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles((theme) => rfiDetailFormStyle(theme));

const TransmittalMaster = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    selectHardCopyHandleOpen,
    submissionValue,
    setSubmissionValue,
    validate,
    validationErrors,
    isNew,
    editable,
    userStageAction,
    downloadFileAction,
    viewFileAction,
    deleteAtthConfirmAction,
  } = props;
  const [followingList, setFollowingList] = useState([]);
  const [purposeList, setPurposeList] = useState([]);

  //Handle Date
  const handleDateFieldChange = (date, name) => {
    const data = { ...submissionValue };
    data[name] = date;
    setSubmissionValue({ ...submissionValue, ...data });
  };

  // Handle Input
  const handleInputChange = (name, validateOnChange) => (event) => {
    const data = { ...submissionValue };
    setSubmissionValue({ ...submissionValue, [name]: event.target.value });
    dispatch({
      type: "ADD_TRANSMITTAL_SUBMISSION_VALUE",
      data: { ...submissionValue, ...data },
    });
    if (validateOnChange) {
      validate({ ...submissionValue, [name]: event.target.value });
    }
  };

  // Handle Checkbox
  const handleCheckboxChange = (type_seq, elementName) => (event) => {
    const { checked } = event.target;
    const data = { ...submissionValue };
    if (checked) {
      data[elementName].push(type_seq);

      setSubmissionValue({ ...submissionValue, ...data });
      dispatch({
        type: "ADD_TRANSMITTAL_SUBMISSION_VALUE",
        data: { ...submissionValue, ...data },
      });
    } else {
      if (data[elementName].indexOf(type_seq) > -1) {
        data[elementName].splice(data[elementName].indexOf(type_seq), 1);
        setSubmissionValue({ ...submissionValue, ...data });
        dispatch({
          type: "ADD_TRANSMITTAL_SUBMISSION_VALUE",
          data: { ...submissionValue, ...data },
        });
      }
    }
    if (
      validationErrors[elementName] && validationErrors[elementName] !== ""
        ? true
        : false
    ) {
      validate({ ...submissionValue, elementName: data[elementName] });
    }
  };

  const getTransmittalFollowing = async () => {
    const response = await getTransmittalFollowingList();
    setFollowingList(response.data);
  };
  const getTransmittalPurpose = async () => {
    const response = await getTransmittalPurposeList();
    setPurposeList(response.data);
  };

  useEffect(() => {
    const fetchTransmittalList = async () => {
      await getTransmittalFollowing();
    };
    fetchTransmittalList();
  }, []);

  useEffect(() => {
    const fetchTransmittalPurposeList = async () => {
      await getTransmittalPurpose();
    };
    fetchTransmittalPurposeList();
  }, []);

  const readOnlyAndDisabled = isNew || editable ? false : true;
  return (
    <Fragment>
      <Grid item xs={12}>
        <Box border={1} borderColor={"grey.500"} className={classes.boxArea}>
          <Typography variant="subtitle1" className={classes.headerText}>
            General Information
          </Typography>
          <Divider className={classes.divider} />
          <Grid item xs={12}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                className={classes.textField}
                id={"date"}
                name={"xmtldate"}
                label={"Transmittal Date"}
                required={true}
                format="dd/MM/yyyy"
                placeholder="DD/MM/YYYY"
                size="small"
                inputVariant="outlined"
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                className={classes.datePickerField}
                value={
                  submissionValue.xmtldate != null
                    ? submissionValue.xmtldate
                    : null
                }
                onChange={(date) =>
                  handleDateFieldChange(
                    date,
                    "xmtldate",
                    validationErrors.xmtldate &&
                      validationErrors.xmtldate !== null
                      ? true
                      : false
                  )
                }
                error={
                  validationErrors.xmtldate &&
                  validationErrors.xmtldate !== null
                    ? true
                    : false
                }
                helperText={validationErrors.xmtldate}
                InputProps={{
                  readOnly: readOnlyAndDisabled,
                }}
                readOnly={readOnlyAndDisabled}
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12}>
            <Box
              border={1}
              borderRadius="borderRadius"
              borderColor={
                validationErrors.following && validationErrors.following !== ""
                  ? "error.main"
                  : "grey.400"
              }
              className={classes.checkboxArea}
            >
              <Typography className={classes.checkBoxTitle}>
                The Following *:
              </Typography>

              {followingList.map((obj, index) => {
                return (
                  <FormControlLabel
                    key={index}
                    className={classes.checkBoxClass}
                    control={
                      <CustomCheckbox
                        required={true}
                        checked={
                          submissionValue.following.indexOf(obj.TYPE_SEQ) > -1
                            ? true
                            : false
                        }
                        onChange={handleCheckboxChange(
                          obj.TYPE_SEQ,
                          "following"
                        )}
                        disabled={readOnlyAndDisabled}
                        name={String(obj.TYPE_SEQ)}
                      />
                    }
                    label={obj.NAME}
                  />
                );
              })}
              <Typography style={{ color: "#f44336", fontSize: "0.75rem" }}>
                {validationErrors.following ? validationErrors.following : ""}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box
              border={1}
              borderRadius="borderRadius"
              borderColor={
                validationErrors.purpose && validationErrors.purpose !== ""
                  ? "error.main"
                  : "grey.400"
              }
              className={classes.checkboxArea}
            >
              <Typography className={classes.checkBoxTitle}>
                Are Transimitted For *:
              </Typography>

              {purposeList.map((obj, index) => {
                return (
                  <FormControlLabel
                    key={index}
                    className={classes.checkBoxClass}
                    control={
                      <CustomCheckbox
                        required={true}
                        checked={
                          submissionValue.purpose.indexOf(obj.TYPE_SEQ) > -1
                            ? true
                            : false
                        }
                        onChange={handleCheckboxChange(obj.TYPE_SEQ, "purpose")}
                        disabled={readOnlyAndDisabled}
                        name={String(obj.TYPE_SEQ)}
                      />
                    }
                    label={obj.NAME}
                  />
                );
              })}
              <Typography style={{ color: "#f44336", fontSize: "0.75rem" }}>
                {validationErrors.purpose ? validationErrors.purpose : ""}
              </Typography>
            </Box>
          </Grid>
          <Grid>
            <TransmittalDocument
              selectHardCopyHandleOpen={selectHardCopyHandleOpen}
              setSubmissionValue={setSubmissionValue}
              submissionValue={submissionValue}
              validate={validate}
              validationErrors={validationErrors}
              isNew={isNew}
              editable={editable}
              viewFileAction={viewFileAction}
              downloadFileAction={downloadFileAction}
              deleteAtthConfirmAction={deleteAtthConfirmAction}
              userStageAction={userStageAction}
            />
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12}>
            <TextField
              className={classes.textField}
              fullWidth={true}
              id={"remarks"}
              name={"remarks"}
              label={"Remark"}
              type="text"
              size="small"
              variant="outlined"
              value={submissionValue.remarks || ""}
              onChange={handleInputChange(
                "remarks",
                validationErrors.remarks && validationErrors.remarks !== ""
                  ? true
                  : false
              )}
              InputProps={{
                readOnly: readOnlyAndDisabled,
                maxLength: 255,
              }}
            />
          </Grid>
        </Box>
      </Grid>
    </Fragment>
  );
};

export default TransmittalMaster;
